export default class InvoiceDetail {
    invNumber?: number | null = null;
    type?: string | null = null;
    endDate?: Date | null = null;
    empNumber?: number | null = null;
    code?: string | null = null;
    description?: string | null = null;
    quantity?: number | null = null;
    rate?: number | null = null;
    amount?: number | null = null;
    orderNumber?: number | null = null;
    lineFormat?: string | null = null;
    classNumber?: number | null = null;
    classCode?: string | null = null;
    classDescription?: string | null = null;
    header?: string | null = null;
    rateType?: string | null;

    [key: string]: string | number | Date | null | undefined;
  }  


// WEBPACK FOOTER //
// ./src/components/project-billing/models/InvoiceDetail.ts